var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { on: { contextmenu: _vm.showContextMenu } },
    [
      _c(
        "drop",
        {
          staticClass: "roomTileContainer elevation-3 drop",
          on: {
            drop: _vm.handleRoomDrop,
            dragover: function($event) {
              _vm.handleRoomDragover.apply(void 0, arguments)
            }
          }
        },
        [
          _c(
            "v-layout",
            {
              staticClass: "roomTileHeader",
              attrs: { row: "" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.showRoomDialog()
                }
              }
            },
            [
              _c(
                "v-flex",
                { staticStyle: { width: "calc(100% - 120px)" } },
                [
                  _c(
                    "span",
                    { staticClass: "roomName", style: _vm.roomNameStyle },
                    [_vm._v(_vm._s(_vm.room.name))]
                  ),
                  _vm.showOccupancyBadge
                    ? _c(
                        "v-chip",
                        {
                          attrs: {
                            color: "grey",
                            "text-color": "white",
                            cursor: "pointer",
                            disabled: ""
                          }
                        },
                        [_vm._v(_vm._s(_vm.badgeText))]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { "text-xs-right": "" } },
                [
                  _c(
                    "span",
                    { staticClass: "roomType", style: _vm.roomTypeStyle },
                    [
                      _vm._v(
                        _vm._s(_vm._f("roomTypeDisplayName")(_vm.roomTypeCode))
                      )
                    ]
                  ),
                  _vm.room.currentNote
                    ? _c(
                        "v-tooltip",
                        { attrs: { top: "" } },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "roomNote",
                              attrs: { slot: "activator", small: "" },
                              slot: "activator"
                            },
                            [_vm._v("fas fa-sticky-note")]
                          ),
                          _c("span", [_vm._v(_vm._s(_vm.room.currentNote))])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm.isBodyVisible
            ? _c(
                "v-flex",
                { staticClass: "stayContainer drop" },
                [
                  _vm.transitionGroupNameForStayTiles !== "off"
                    ? _c(
                        "transition-group",
                        {
                          attrs: { name: _vm.transitionGroupNameForStayTiles }
                        },
                        _vm._l(_vm.room.stays, function(stay) {
                          return _vm.room.stays
                            ? _c(
                                "drag",
                                {
                                  key: stay.bedBoardStayID.id,
                                  staticClass: "drag",
                                  attrs: {
                                    draggable: _vm.isStayActionable(stay),
                                    "transfer-data": _vm.getDragTransferData(
                                      stay
                                    )
                                  },
                                  on: {
                                    dragstart: function($event) {
                                      _vm.handleStayDragStart()
                                    },
                                    dragend: function($event) {
                                      _vm.handleStayDragEnd()
                                    }
                                  }
                                },
                                [
                                  _c("stay-tile", {
                                    staticClass: "stayTile elevation-2",
                                    attrs: {
                                      room: _vm.room,
                                      stay: stay,
                                      unit: _vm.unit
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        })
                      )
                    : _vm._e(),
                  _vm.transitionGroupNameForStayTiles === "off"
                    ? _c(
                        "div",
                        _vm._l(_vm.room.stays, function(stay) {
                          return _vm.room.stays
                            ? _c(
                                "drag",
                                {
                                  key: stay.bedBoardStayID.id,
                                  staticClass: "drag",
                                  attrs: {
                                    draggable: _vm.isStayActionable(stay),
                                    "transfer-data": _vm.getDragTransferData(
                                      stay
                                    )
                                  },
                                  on: {
                                    dragstart: function($event) {
                                      _vm.handleStayDragStart()
                                    },
                                    dragend: function($event) {
                                      _vm.handleStayDragEnd()
                                    }
                                  }
                                },
                                [
                                  _c("stay-tile", {
                                    staticClass: "stayTile elevation-2",
                                    attrs: {
                                      room: _vm.room,
                                      stay: stay,
                                      unit: _vm.unit
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        })
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm.isRoomDialogVisible
        ? _c(
            "v-dialog",
            {
              attrs: { scrollable: "", "min-height": "90%", width: "90%" },
              model: {
                value: _vm.isRoomDialogVisible,
                callback: function($$v) {
                  _vm.isRoomDialogVisible = $$v
                },
                expression: "isRoomDialogVisible"
              }
            },
            [
              _c(
                "v-flex",
                [
                  _c("room-card", {
                    attrs: {
                      unit: _vm.unit,
                      room: _vm.roomCopy,
                      isEditable: _vm.unit.isRoomEditingAllowed,
                      onCancel: _vm.closeRoomDialog,
                      onSave: _vm.saveRoom
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isAssignClientDialogVisible
        ? _c(
            "v-dialog",
            {
              attrs: { width: "90%" },
              model: {
                value: _vm.isAssignClientDialogVisible,
                callback: function($$v) {
                  _vm.isAssignClientDialogVisible = $$v
                },
                expression: "isAssignClientDialogVisible"
              }
            },
            [
              _c(
                "v-flex",
                [
                  _c("assign-client", {
                    attrs: {
                      unit: _vm.unit,
                      room: _vm.room,
                      onCancel: _vm.closeAssignClientDialog,
                      onAssign: _vm.assignClient
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isMoveConfirmationDialogVisible
        ? _c(
            "v-dialog",
            {
              attrs: { height: "300px", width: "500px" },
              model: {
                value: _vm.isMoveConfirmationDialogVisible,
                callback: function($$v) {
                  _vm.isMoveConfirmationDialogVisible = $$v
                },
                expression: "isMoveConfirmationDialogVisible"
              }
            },
            [
              _c(
                "v-flex",
                [
                  _c("move-confirmation", {
                    attrs: {
                      moveParams: _vm.moveParams,
                      onCancel: _vm.closeMoveConfirmationDialog,
                      onMove: _vm.moveStay
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-menu",
        {
          attrs: {
            "position-x": _vm.x,
            "position-y": _vm.y,
            absolute: "",
            "offset-y": ""
          },
          model: {
            value: _vm.isContextMenuVisible,
            callback: function($$v) {
              _vm.isContextMenuVisible = $$v
            },
            expression: "isContextMenuVisible"
          }
        },
        [
          _c(
            "v-list",
            [
              _c(
                "v-list-tile",
                {
                  on: {
                    click: function($event) {
                      _vm.showRoomDialog()
                    }
                  }
                },
                [_vm._v("Update Room Settings")]
              ),
              _vm.unit.isAssignStayAllowed
                ? _c(
                    "v-list-tile",
                    {
                      on: {
                        click: function($event) {
                          _vm.showAssignClientDialog()
                        }
                      }
                    },
                    [_vm._v("Assign Client")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }